import * as Styled from "./style";
import type { G_VideoCampaign } from "~/lib/graphql";
import { formatDateToYMDDayHm } from "~/util/format-date";

type Props = {
  campaign?: Pick<G_VideoCampaign, "endAt" | "name"> | null;
};

export const PremiumLimitedTag = (props: Props) => {
  const { campaign } = props;

  if (campaign === undefined || campaign === null) return null;

  const { name, endAt } = campaign;

  if (new Date(endAt).getTime() < Date.now()) return null;

  const subText = `${name} ${formatDateToYMDDayHm(endAt)}まで`;

  return (
    <Styled.TagFlexWrapRoot>
      <Styled.PremiumLimitedTag
        tagText="DMMプレミアム特別価格"
        bgColor="YELLOW50"
        subTextColor="YELLOW50"
        color="GRAY50"
      />
      <Styled.ParPremiumLimitedTagSubText>{subText}</Styled.ParPremiumLimitedTagSubText>
    </Styled.TagFlexWrapRoot>
  );
};
